module.exports = __webpack_public_path__ + "static/media/Gjerne.4b34be0f.mp3";